// extracted by mini-css-extract-plugin
module.exports = {"picture":"e_zk","image":"e_Ak","imageInverted":"e_Bk","company":"e_Ck","subscriptionName":"e_Dk","text":"e_Ek","readMoreLink":"e_Fk","checkbox":"e_Gk"};